module.exports = __webpack_public_path__ + "static/media/sniper-0.1e558523.png";